import { useSelector, useDispatch } from "react-redux";
import axios from "axios";

import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import RectangleIcon from "@mui/icons-material/Rectangle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

import { overlayActions } from "../../store";

import React from "react";
const OverlaysLegend = () => {
  const dispatch = useDispatch();
  const overlayState = useSelector((state) => state.overlay);

  const cellStyle = { m: 0, p: 0, color: "#eee", fontSize: "0.8rem" };
  const footerStyle = { fontSize: "0.7rem", pt: 1 };

  async function getOverlayLegend(url, overlayId) {
    await axios.get(url).then((response) => {
      dispatch(
        overlayActions.setLegendData({ overlayId, data: response.data })
      );
    });
  }

  return (
    <>
      {Object.keys(overlayState)
        .filter((overlayId) => overlayState[overlayId].active)
        .map((overlayId, index) => {
          if (overlayState[overlayId].legendConfig) {
            switch (overlayState[overlayId].legendConfig.legendType) {
              case "static-categorical":
                return (
                  <React.Fragment key={overlayId}>
                    {index > 0 && <Divider />}
                    <TableContainer
                      sx={{ ml: 2, mr: 2, pt: 2, pb: 2, width: "auto" }}
                    >
                      <Typography>{overlayState[overlayId].name}</Typography>
                      <Table
                        sx={{
                          [`& .${tableCellClasses.root}`]: {
                            borderBottom: "none",
                          },
                        }}
                      >
                        <TableBody>
                          {overlayState[
                            overlayId
                          ].legendConfig.legendValues.map((row) => (
                            <TableRow key={row.value} sx={{ border: "none" }}>
                              <TableCell
                                sx={{ ...cellStyle, display: "flex" }}
                                component="th"
                                scope="row"
                              >
                                <RectangleIcon sx={{ m: 0, color: row.hex }} />
                              </TableCell>
                              <TableCell sx={cellStyle} align="left">
                                {row.value}
                              </TableCell>
                              <TableCell sx={cellStyle} align="left">
                                {row.description}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      {overlayState[overlayId].legendConfig.comment && (
                        <Typography sx={footerStyle}>
                          {overlayState[overlayId].legendConfig.comment}
                        </Typography>
                      )}

                      {overlayState[overlayId].legendConfig.dataSource && (
                        <Typography sx={footerStyle}>
                          Data Source:{" "}
                          <Link
                            href={
                              overlayState[overlayId].legendConfig.dataSource
                                .url
                            }
                            sx={footerStyle}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            {
                              overlayState[overlayId].legendConfig.dataSource
                                .label
                            }
                          </Link>
                        </Typography>
                      )}
                    </TableContainer>
                  </React.Fragment>
                );

              case "arcGis":
                if (!overlayState[overlayId].legendData) {
                  getOverlayLegend(
                    overlayState[overlayId].legendConfig.legendUrl,
                    overlayId
                  );
                  return (
                    <React.Fragment key={overlayId}>
                      {index > 0 && <Divider />}
                      <Box
                        sx={{
                          p: 1,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    </React.Fragment>
                  );
                } else {
                  const arcGisLayers = overlayState[
                    overlayId
                  ].legendData.layers.filter((layer) =>
                    overlayState[overlayId].legendConfig.arcGisLayers.includes(
                      layer.layerId
                    )
                  );

                  return (
                    <React.Fragment key={overlayId}>
                      {index > 0 && <Divider />}
                      <TableContainer sx={{ p: 2 }}>
                        <Typography>{overlayState[overlayId].name}</Typography>
                        {arcGisLayers.map((arcGisLayer) => (
                          <React.Fragment key={arcGisLayer.layerName}>
                            <Typography
                              sx={{
                                fontSize: "0.7rem",
                                textTransform: "uppercase",
                              }}
                            >
                              {arcGisLayer.layerName}
                            </Typography>

                            <Table
                              sx={{
                                [`& .${tableCellClasses.root}`]: {
                                  borderBottom: "none",
                                },
                              }}
                            >
                              <TableBody>
                                {arcGisLayer.legend.map((row) => {
                                  return (
                                    <TableRow
                                      key={row.url}
                                      sx={{ border: "none" }}
                                    >
                                      <TableCell
                                        sx={{ ...cellStyle, display: "flex" }}
                                        component="th"
                                        scope="row"
                                      >
                                        <Box
                                          sx={{
                                            height: "25px",
                                            width: "25px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <img
                                            src={`${overlayState[overlayId].serviceBaseUrl}/${arcGisLayer.layerId}/images/${row.url}`}
                                            alt={row.label}
                                          />
                                        </Box>
                                      </TableCell>
                                      <TableCell sx={cellStyle} align="left">
                                        {row.label}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </React.Fragment>
                        ))}
                        {overlayState[overlayId].legendConfig.dataSource && (
                          <Typography sx={footerStyle}>
                            Data Source:{" "}
                            <Link
                              href={
                                overlayState[overlayId].legendConfig.dataSource
                                  .url
                              }
                              sx={footerStyle}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              {
                                overlayState[overlayId].legendConfig.dataSource
                                  .label
                              }
                            </Link>
                          </Typography>
                        )}
                      </TableContainer>
                    </React.Fragment>
                  );
                }
              default:
                break;
            }
          }
          return null;
        })}
    </>
  );
};

export default OverlaysLegend;
